import { Injectable } from '@angular/core';
import { FgiBackEndService } from 'src/app/shared/fgi-back-end.service';
import { AditivoOperacaoCreditoLivre } from 'src/app/model/operacao-garantida.model';
import { RetornoMensagemSimplesDTO } from 'src/app/model/questionario.model';
import { Observable, of } from 'rxjs';
import { blockUi } from "@bndes/bndes-ux4/bndes-angular-utils";
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AditivoOperacaoCreditoLivreService extends FgiBackEndService<AditivoOperacaoCreditoLivre> {

  // @Override
  getNewEntity() {
    return new AditivoOperacaoCreditoLivre();
  }

  // @Override
  protected getResourceURL(): string {
    return 'front/credito-livre/aditivos';
  }

  public cancelarAditivo(idAditivo: number): Observable<RetornoMensagemSimplesDTO> {
    return this.http.post(`${this.BASE_URL}/${idAditivo}/cancelar`, {}, blockUi()).pipe(
           catchError((e) => this.handleError(e))) as Observable<RetornoMensagemSimplesDTO>;
  }
}